<template>

  <div id="signin">

    <nav class="navbar navbar-expand-lg scrolling-navbar d-flex justify-content-between" style="background-color: #00948a; padding: 0rem 1rem;">
      <img src="../../../public/logo.png" style="width: 190px; background-color: white" >
      <div class=" ">
        <b-button v-b-modal.modal-1 variant="light">Sign In</b-button>

        <b-modal id="modal-1" title="" hide-footer>

            <form @submit.prevent="onSubmit" class="text-dark">

              <h3 class="">Sign In</h3>
              <b-alert :show="alert" variant="danger">Incorect username or password</b-alert>
              <div class="form-group">
                <label>Email:</label>
                <input  type="text"
                        id="text"
                        v-model="username"  class="form-control form-control-lg" />
              </div>

              <div class="form-group">
                <label>Password:</label>
                <input type="password"
                       id="password"
                       v-model="password" class="form-control form-control-lg" />
              </div>

              <button type="submit" class="button btn btn-lg btn-block " style="  border: 2px solid #6ae542;">Sign In</button>
            </form>

        </b-modal>

      </div>

    </nav>
    <component-home></component-home>
  </div>
</template>

<script>
  import store from "../../store";
  import home from './firsthome'
  export default {
    components:{
      'component-home': home,
    },
    data () {
      return {
        username: '',
        password: '',
        alert:false,
      }
    },
    methods: {
      async onSubmit () {
        const formData = {
          username: this.username,
          password: this.password,
        }
        //console.log(formData)
        this.username = this.username.replace(/\s/g, '');
        //console.log(this.username)
        localStorage.setItem('username', this.username)
       await this.$store.dispatch('login', {username: formData.username, password: formData.password})
       //console.log(store.getters.user)
       if(store.getters.user===null){
         //console.log('here')
          this.alert=true
       }
        /*
        if (store.getters.isAuthenticated) {
          console.log('heredashboard')
          this.$router.push('dashboard')
        } else {
          console.log('heresignin')
          console.log(store.getters.isAuthenticated)
          this.$router.push('signin')
        }
        */
      }


    }
  }
</script>

<style scoped>
.button:hover {
  background-color: #6ae542; /* Green */
  color: white;
}

  .signin-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .submit button {
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
  }

  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
.navbar .btn {
   margin: 0px 0px;
}

</style>
